/**
 * SendGrid Sync Service
 *
 * The app copies its families into SendGrid Marketing Contacts, grouped
 * into lists by area, program and class, with filter fields on each
 * contact. A run happens nightly and on demand; it works in the background,
 * so `run` only queues it and `status` reports how it went.
 */

import apiClient from "../client";
import { API_ENDPOINTS } from "../../constants/api.constants";

const base = API_ENDPOINTS.ADMIN.SENDGRID_SYNC;

const sendgridSyncService = {
  /** @returns {Promise<{enabled, has_api_key, live, running, last_run, lists, fields}>} */
  async status() {
    const { data } = await apiClient.get(`${base}/status`);
    return data;
  },

  /** Queues a sync. Rejects with 409 while one is already running. */
  async run() {
    const { data } = await apiClient.post(`${base}/run`);
    return data;
  },
};

export default sendgridSyncService;
